import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import PreviousResult from "@/pages/PreviousResult";
import CommonNumber from "@/pages/CommonNumber";
import Blog from "@/pages/Blog";
import DreamNumber from "@/pages/DreamNumber";
import Analytics from "@/pages/Analytics";
import PredictTarget from "@/pages/PredictTarget";
import TeerCalendar from "@/pages/TeerCalendar";
import ReputedCounters from "@/pages/ReputedCounters";
import AdminApp from "@/pages/admin/AdminApp";
import InfoPage from "@/pages/InfoPage";
import NotFound from "@/pages/NotFound";

const infoSlugs = [
  "morning-teer",
  "about-us",
  "contact-us",
  "privacy-policy",
  "disclaimer",
  "terms-conditions",
];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/previous-result" element={<PreviousResult />} />
        <Route path="/common-number" element={<CommonNumber />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/dream-number" element={<DreamNumber />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/predict-target" element={<PredictTarget />} />
        <Route path="/teer-calendar" element={<TeerCalendar />} />
        <Route path="/reputed-counters" element={<ReputedCounters />} />
        <Route path="/admin" element={<AdminApp />} />
        <Route path="/admin/*" element={<AdminApp />} />
        {infoSlugs.map((slug) => (
          <Route
            key={slug}
            path={`/${slug}`}
            element={<InfoPage slug={slug} />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
